import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  promocionesList:[],
  listPromocionesTotal:[],
  tocasList:[],
  currentOrden: JSON.parse(localStorage.getItem("currentOrden")) || ''
};

export const mutations = {
  GET_PROMOCIONES({ context }, promociones) {
    let promociones_array = [];
    Object.entries(promociones).forEach(([key, val]) => promociones_array.push(val));
    return (state.promocionesList = promociones_array);
  },
  GET_PROMOCIONES_SALAS({ context }, salas) {
    let salas_array = [];
    Object.entries(salas).forEach(([key, val]) => salas_array.push(val));
    return (state.listPromocionesTotal = salas_array);
  },
  GET_TOCAS({ context }, tocas) {
    let tocas_array = [];
    Object.entries(tocas).forEach(([key, val]) => tocas_array.push(val));
    return (state.tocasList = tocas_array);
  },
  SHOW_PROMOCION ({ context }, promocion) {
    state.currentOrden = Object.assign({}, promocion);
    localStorage.setItem("currentOrden", JSON.stringify(state.currentOrden));
  }
};

export const actions = {
  GET_PROMOCIONES({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          // console.log(response.data);
          commit("GET_PROMOCIONES", response.data.data.promociones);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  GET_PROMOCIONES_SALAS({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          // console.log(response.data);
          commit("GET_PROMOCIONES_SALAS", response.data.data.salas);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  GET_TOCAS({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          // console.log(response.data);
          commit("GET_TOCAS", response.data.data.tocas);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  SAVE_INITIAL_PROMOCION({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(data)
        .then(response => {
          commit("SET_LOADING", false);
          // commit("SHOW_PROMOCION", response.data.data.promocion);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  SHOW_PROMOCION({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("SHOW_PROMOCION", response.data.data.promocion);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  SEND_PROMOCION({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(data)
        .then(response => {
          commit("SET_LOADING", false);
          //commit("SEND_PROMOCION", response.data.data.promocion);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  SET_JUEZ({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(data)
        .then(response => {
          commit("SET_LOADING", false);
          //commit("SET_JUEZ", response.data.data.promocion);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  }

};
export const getters = {
  promocionesList: state => state.promocionesList,
  listPromocionesTotal: state => state.listPromocionesTotal,
  tocasList: state => state.tocasList,
  //currentOrden: state => state.currentOrden,
};
